import { Mutation } from "../types";

export default {
  [Mutation.ADDMESSAGE](state, payload) {
    localStorage.setItem("message", payload.message);
    state.message = payload.message;
  },
  [Mutation.DELMESSAGE](state) {
    localStorage.removeItem("message");
    state.message = "";
  }
};
